export enum ForloebStatusEnum {
    Ledig = "ledig",
    Optaget = "optaget"
}
